/* BC adopted permanent UTC-7 at 2026-03-08T10:00Z. Use explicit wall time
   after that instant so older browser timezone databases cannot fall back. */
(function (root) {
  const transition = Date.UTC(2026, 2, 8, 10);
  function context(date, options, timeZone) {
    const bc = timeZone === 'America/Vancouver' && date.getTime() >= transition;
    const settings = {...options, timeZone: bc ? 'UTC' : timeZone};
    if (bc) delete settings.timeZoneName;
    return {date: bc ? new Date(date.getTime() - 7 * 3600000) : date, settings, bc};
  }
  root.YCClassTime = {
    format(date, locale, options, timeZone = 'America/Vancouver') {
      const view = context(date, options, timeZone);
      const text = new Intl.DateTimeFormat(locale, view.settings).format(view.date);
      return view.bc && options.timeZoneName ? text + ' PT' : text;
    },
    parts(date, locale, options, timeZone = 'America/Vancouver') {
      const view = context(date, options, timeZone);
      return new Intl.DateTimeFormat(locale, view.settings).formatToParts(view.date);
    }
  };
})(typeof window === 'undefined' ? globalThis : window);
